import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AemService } from './aem.service';
import { UserInfoService } from './user-info.service';
import { EnviormentConfig } from '../wcax-env-config';
import { CommonService } from './common.service';

@Injectable({
    providedIn: 'root',
})
export class MylistService {
    url: string;
    myListHttpHeaders: any = {};
    private config = EnviormentConfig;

    public currentEnv = '';

    public constructor(public http: HttpClient, private aemService: AemService, private userInfoService: UserInfoService, private _commonService: CommonService) {
        this.currentEnv = this._commonService.getCurrentEnviorment();
    }

    public getMyList(storeId, isWeeklyAdPznActive) {
        const rand = Math.floor(Math.random() * Number.MAX_SAFE_INTEGER).toString();
        this.myListHttpHeaders = {...{}, ...this.aemService.getJ4uHttpOptions11()};
        
        if (this.userInfoService.getSWY_SHOP_TOKEN()) {
            this.myListHttpHeaders['SWY_sso_token'] = `${this.userInfoService.getSWY_SHOP_TOKEN()}`;
            this.myListHttpHeaders['Swyconsumerdirectorypro'] = `${this.userInfoService.getSWY_SHOP_TOKEN()}`;
        }
        if (isWeeklyAdPznActive) {
            delete this.myListHttpHeaders['X-SWY_VERSION'];
            this.myListHttpHeaders['X-Swy_version'] = '4.0'
        }
        const options = {
            headers: {
                ...this.myListHttpHeaders,
            },
            params: {
                storeId: storeId,
                rand: rand,
            },
            withCredentials: true,
        };

        const banner = this.userInfoService.getBanner() || window['AB']['userInfo']['banner'];

        this.url = window['SWY'].CONFIGSERVICE.bannerDomainMap['www-' + banner] + window['AB'].myListPath;
        return this.http.get(this.url, options);
    }

    public getMyListSync(storeId, isWeeklyAdPznActive) {
        const rand = Math.floor(Math.random() * Number.MAX_SAFE_INTEGER).toString();
        this.myListHttpHeaders = {...{}, ...window['AB'].j4uHttpOptions11};
        if (this.userInfoService.getSWY_SHOP_TOKEN()) {
            this.myListHttpHeaders['SWY_sso_token'] = `${this.userInfoService.getSWY_SHOP_TOKEN()}`;
            this.myListHttpHeaders['Swyconsumerdirectorypro'] = `${this.userInfoService.getSWY_SHOP_TOKEN()}`;
        }
        if (isWeeklyAdPznActive) {
            delete this.myListHttpHeaders['X-SWY_VERSION'];
            this.myListHttpHeaders['X-Swy_version'] = '4.0'
        }
        const banner = this.userInfoService.getBanner() || window['AB']['userInfo']['banner'];
        this.url = window['SWY'].CONFIGSERVICE.bannerDomainMap['www-' + banner] + window['AB'].myListPath + '?storeId=' + storeId + '&rand=' + rand;
        const request = new XMLHttpRequest();
        request.open('GET', this.url, false);  // `false` makes the request synchronous
        Object.keys(this.myListHttpHeaders).forEach(key => {
            console.warn(key + ' : ' + this.myListHttpHeaders[key]);
            request.setRequestHeader(key, this.myListHttpHeaders[key]);
        });
        request.withCredentials = true;
        request.send(null);
        if (request.status == 200) {
            return request.responseText;
        } else {
            return '{}';
        }
    }
}
